import React from 'react';
import './WIEMTIGhana2018.css';

const WIEMTIGhana2018 = () => {
  return (
    <div className="wiemti-page">
      {/* Hero Section */}
      <section className="wiemti-hero">
        <div className="wiemti-hero-content">
          <span className="wiemti-badge">SUMMIT REPORT 2018</span>
          <h1>WIEMTI-Ghana 2018</h1>
          <p className="wiemti-subtitle">West Africa Infrastructure, Energy, Mining, Trade Exhibition & Investment Summit</p>
          <div className="wiemti-meta">
            <span>📍 Accra, Ghana</span>
            <span>📅 5-7 December 2018</span>
            <span>🏛️ Tang Palace Hotel</span>
          </div>
          <div className="wiemti-stats">
            <div className="stat-item">
              <span className="stat-number">300+</span>
              <span className="stat-label">Delegates</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">16</span>
              <span className="stat-label">Countries</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">25+</span>
              <span className="stat-label">Speakers</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">10+</span>
              <span className="stat-label">Sectors Covered</span>
            </div>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="wiemti-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-text">
              <h2>Summit Overview</h2>
              <p>
                The West Africa Infrastructure, Energy, Mining, Trade Exhibition & Investment Summit 
                (WIEMTI) 2018 was a landmark event held in Accra, Ghana, from 5-7 December 2018. 
                Organized by the Africa Business Ventures & Investment Group (ABVIG) in partnership 
                with the Ministry of Trade and Industry Ghana, the Ministry of Business Development 
                (Office of the President, Republic of Ghana), and the Nigeria Permanent Representative 
                to ECOWAS, the summit brought together over 300 delegates from across the sub-region 
                and beyond.
              </p>
              <p>
                Under the theme <strong>"Solving Energy Challenges and Increasing Economic Growth to 
                Accelerate Regional Integration and Development through Harnessing the Business and 
                Investment Opportunities in West Africa,"</strong> the summit addressed critical issues 
                facing the region.
              </p>
            </div>
            <div className="overview-image">
              <img src="/images/wiemti-overview.jpg" alt="WIEMTI Summit Overview" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="wiemti-about">
        <div className="container">
          <h2 className="section-title">Aim & Objective</h2>
          <div className="about-grid">
            <div className="about-card">
              <div className="about-icon">🎯</div>
              <h3>Business Matching</h3>
              <p>To bring together over 300 Sub-regional and International Delegates and Trade Exhibitors for face-to-face business and investment matching sessions with key industrial players.</p>
            </div>
            <div className="about-card">
              <div className="about-icon">🤝</div>
              <h3>Public-Private Forum</h3>
              <p>An invaluable forum for high-level government Ministers, agencies, CEOs, and investors to interact, exchange knowledge, and explore new ways for achieving developmental targets.</p>
            </div>
            <div className="about-card">
              <div className="about-icon">💼</div>
              <h3>Finding Partners</h3>
              <p>The ultimate goal was to ensure that every participant finds a matching business partner for sustainable growth and economic impact.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Issues Section */}
      <section className="wiemti-issues">
        <div className="container">
          <h2 className="section-title">Key Issues Addressed</h2>
          <div className="issues-grid">
            <div className="issue-item">
              <span className="issue-icon">⚡</span>
              <div>
                <h4>Energy Access & Cost</h4>
                <p>Addressing the challenges of unreliable and expensive energy supply for both domestic and industrial use.</p>
              </div>
            </div>
            <div className="issue-item">
              <span className="issue-icon">🚧</span>
              <div>
                <h4>Trade Barriers</h4>
                <p>Identifying and proposing solutions to remove obstacles hindering free trade and regional integration.</p>
              </div>
            </div>
            <div className="issue-item">
              <span className="issue-icon">🌍</span>
              <div>
                <h4>Regional Integration</h4>
                <p>Accelerating economic growth through harnessing energy, mining, and trade opportunities in West Africa.</p>
              </div>
            </div>
            <div className="issue-item">
              <span className="issue-icon">📜</span>
              <div>
                <h4>Policy Framework</h4>
                <p>Discussing the policy gaps and the need for strong institutional and regulatory frameworks to attract investment.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Speakers Section */}
      <section className="wiemti-speakers">
        <div className="container">
          <h2 className="section-title">Distinguished Speakers & Panelists</h2>
          <div className="speakers-grid">
            <div className="speaker-card">
              <img src="/images/speakers/senator-naamo.jpg" alt="Senator Abubakar Na'amo Abdullahi" />
              <h4>Sen. Abubakar Na'amo Abdullahi</h4>
              <p>Former Senator, Federal Republic of Nigeria</p>
            </div>
            <div className="speaker-card">
              <img src="/images/speakers/amb-nurudeen.jpg" alt="Amb. Babatunde Ayinla Nurudeen" />
              <h4>Amb. Babatunde A. Nurudeen</h4>
              <p>Permanent Rep. of Nigeria to ECOWAS</p>
            </div>
            <div className="speaker-card">
              <img src="/images/speakers/moses-owharo.jpg" alt="Moses O.T. Owharo" />
              <h4>Moses O.T. Owharo</h4>
              <p>Chairman, Organizing Committee, ABVIG</p>
            </div>
            <div className="speaker-card">
              <img src="/images/speakers/debo-barandao.jpg" alt="Debo-K'mba A. Barandao" />
              <h4>Debo-K'mba A. Barandao</h4>
              <p>Director General, WAGP Authority</p>
            </div>
            <div className="speaker-card">
              <img src="/images/speakers/dr-ashley.jpg" alt="Dr. Ebenezer M. Ashley" />
              <h4>Dr. Ebenezer M. Ashley</h4>
              <p>Facilitator & Presenter</p>
            </div>
            <div className="speaker-card">
              <img src="/images/speakers/grace-alupo.jpg" alt="Grace Alupo" />
              <h4>Grace Alupo</h4>
              <p>Dreamtrips Worldwide, USA</p>
            </div>
            <div className="speaker-card">
              <img src="/images/speakers/dr-ayoola-amale.jpg" alt="Dr. Ayo Ayoola-Amale" />
              <h4>Dr. Ayo Ayoola-Amale</h4>
              <p>Peace Activist & Poet</p>
            </div>
            <div className="speaker-card">
              <img src="/images/speakers/olajide.jpg" alt="Olajide A. B." />
              <h4>Olajide A. B.</h4>
              <p>Deputy Director, Federal Ministry of Trade, Nigeria</p>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery Section */}
      <section className="wiemti-gallery">
        <div className="container">
          <h2 className="section-title">Summit Highlights</h2>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img src="/images/wiemti/gallery-1.jpg" alt="Summit group" />
            </div>
            <div className="gallery-item">
              <img src="/images/wiemti/gallery-2.jpg" alt="Speakers and delegates" />
            </div>
            <div className="gallery-item">
              <img src="/images/wiemti/gallery-3.jpg" alt="Presentation session" />
            </div>
            <div className="gallery-item">
              <img src="/images/wiemti/gallery-4.jpg" alt="Networking session" />
            </div>
            <div className="gallery-item">
              <img src="/images/wiemti/gallery-5.jpg" alt="Award ceremony" />
            </div>
            <div className="gallery-item">
              <img src="/images/wiemti/gallery-6.jpg" alt="Panel discussion" />
            </div>
          </div>
        </div>
      </section>

      {/* Key Topics Section */}
      <section className="wiemti-topics">
        <div className="container">
          <h2 className="section-title">Keynote Topics</h2>
          <div className="topics-list">
            <div className="topic-item">
              <span className="topic-number">01</span>
              <div>
                <h4>Private Public Partnership (PPP) Role in Building Effective Sustainable Economy</h4>
                <p>Presented by Amb. Babatunde Ayinla Nurudeen, Permanent Representative of Nigeria to ECOWAS</p>
              </div>
            </div>
            <div className="topic-item">
              <span className="topic-number">02</span>
              <div>
                <h4>Mitigating Gaps, Challenges and Opportunities in the Oil and Gas Development of West Africa</h4>
                <p>Presented by Debo-K'mba A. Barandao, Director General, WAGP Authority</p>
              </div>
            </div>
            <div className="topic-item">
              <span className="topic-number">03</span>
              <div>
                <h4>Investment Opportunities in Nigeria</h4>
                <p>Presented by Olajide A. B., Deputy Director, Federal Ministry of Industry, Trade and Investment, Nigeria</p>
              </div>
            </div>
            <div className="topic-item">
              <span className="topic-number">04</span>
              <div>
                <h4>Financial Implication of Crypto Currency</h4>
                <p>Presented by Dr. Ebenezer M. Ashley, Ghana</p>
              </div>
            </div>
            <div className="topic-item">
              <span className="topic-number">05</span>
              <div>
                <h4>Trade Conflict Resolution - As a Vehicle for Investment, Sustainability and Economic Growth</h4>
                <p>Presented by Dr. Ayo Ayoola-Amale, Ghana</p>
              </div>
            </div>
            <div className="topic-item">
              <span className="topic-number">06</span>
              <div>
                <h4>Urgent Need for Joint and Sustained Efforts for Peace and Development in Sub-Sahara Africa</h4>
                <p>Presented by Senator Abubakar Na'amo Abdullahi, Nigeria</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Awards Section */}
      <section className="wiemti-awards">
        <div className="container">
          <h2 className="section-title">Awards & Recognition</h2>
          <div className="awards-grid">
            <div className="award-card">
              <div className="award-icon">🏆</div>
              <h4>Ministry of Trade and Industry, Ghana</h4>
              <p>Policy Reform</p>
            </div>
            <div className="award-card">
              <div className="award-icon">🏆</div>
              <h4>Federal Ministry of Trade, Industry and Investment, Nigeria</h4>
              <p>Policy Reform & Investment Promotion</p>
            </div>
            <div className="award-card">
              <div className="award-icon">🏆</div>
              <h4>Ministry of Foreign Affairs, Nigeria</h4>
              <p>Helping Uplift Trade Embargo on International Trade</p>
            </div>
            <div className="award-card">
              <div className="award-icon">🏆</div>
              <h4>Amb. Babatunde Ayinla Nurudeen</h4>
              <p>Permanent Representative of Nigeria to ECOWAS</p>
            </div>
          </div>
        </div>
      </section>

      {/* Recommendations Section */}
      <section className="wiemti-recommendations">
        <div className="container">
          <h2 className="section-title">Summit Recommendations</h2>
          <div className="recommendations-list">
            <div className="recommendation-item">
              <span className="rec-number">1</span>
              <p>Secure firm commitment from Host country's Government and Key regional bodies like ECOWAS Commission</p>
            </div>
            <div className="recommendation-item">
              <span className="rec-number">2</span>
              <p>Period of organization should be at least 5 months to ensure full participation of ECOWAS stakeholders</p>
            </div>
            <div className="recommendation-item">
              <span className="rec-number">3</span>
              <p>Strong marketing and promotion team to ensure participation of the private sector</p>
            </div>
          </div>
        </div>
      </section>

      {/* Conclusion */}
      <section className="wiemti-conclusion">
        <div className="container">
          <div className="conclusion-content">
            <h2>A Successful Summit</h2>
            <p>
              The WIEMTI 2018 Summit successfully brought together key stakeholders from across the 
              West African sub-region to address critical challenges in energy, infrastructure, mining, 
              and trade. The event facilitated meaningful business connections, knowledge sharing, and 
              the recognition of excellence, setting the stage for continued regional integration and 
              economic development.
            </p>
            <div className="conclusion-meta">
              <span>📅 5-7 December 2018</span>
              <span>📍 Accra, Ghana</span>
              <span>🏛️ Tang Palace Hotel</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WIEMTIGhana2018;